import "./HeaderSection.scss";

export const HeaderSection = () => {

  return (
    <header id="home" className="hero-header">
      <div className="hero-header__overlay" />
    </header>
  );
};